import MarkdownSectionImplementation from '../implementation/sections/MarkdownSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiMarkdownSectionDTO,
  MarkdownSectionDTO,
} from '@lib/strapi/dtos/components/sections/markdownSection.dto';

const MarkdownSection = (props: ComponentProps<MarkdownSectionDTO>) => {
  return <MarkdownSectionImplementation {...props}></MarkdownSectionImplementation>;
};

export default MarkdownSection;
